export default __webpack_public_path__ + "static/media/Client Logos – 07 – Audition Showdown.e8cdbbf5.svg";